<template>
  <div class="w-full">
    <div class="flex flex-col items-center relative" v-click-outside="ocultar">
      <div class="w-full">
        <label class="block" :class="label_class?label_class:'text-sm font-medium text-gray-700'">{{ label }}
          <div class="my-2 p-1 bg-white flex border  rounded"
               :class="state===false? 'border-red-500':state===true?'border-green-500':'focus:border-gray-200'">
            <input :placeholder="placeholder"
                   class="p-1 px-2 appearance-none outline-none w-full text-gray-800 active:bg-blue"
                   @focus="changeShowDetail"
                   @keyup.esc="changeShowDetail" @keyup="isShow($event)"
                  :value="text" @input="($event)=>text=$event.target.value" ref="autocomplete" :disabled="disabled">
            <div class="text-gray-300 w-8 py-1 pl-2 pr-1 border-l flex items-center border-gray-200">
              <button class="cursor-pointer w-6 h-6 text-gray-600 outline-none focus:outline-none" :disabled="disabled"
                      @touchstart="changeShowDetail" type="button" @click.prevent="changeShowDetail">
                <font-awesome-icon icon="chevron-up" v-if="showDetail"></font-awesome-icon>
                <font-awesome-icon icon="chevron-down" v-else></font-awesome-icon>
              </button>
            </div>
          </div>
          <!--          warning-message-->
          <span class="flex items-center font-medium tracking-wide text-xs mt-1 ml-1"
                :class="state===true?'text-green-500':'text-red-500'"
                v-if="state!==null">
			          {{ state === true ? validMessage : errorMessage }}
		        </span>
        </label>
      </div>
      <div v-if="showDetail"
           class="absolute shadow bg-white top-100 z-40 w-full lef-0 rounded max-h-select overflow-y-auto svelte-5uyqqj max-h-select"
           ref="autocompletedetail">
        <ul class="flex flex-col w-full">
          <li class="cursor-pointer w-full border-gray-200 rounded-t border-b  py-2 "
              :class="indexElementActive===index ? 'bg-blue-300': ''"
              v-for="(item, index) in searching" :key="index" @click="selectItem(item)"
              :ref="refElement(index)">
            <div
                class="flex w-full items-center p-2 pl-2 border-transparent border-l-2 relative hover:border-teal-100">
              <div class="w-6 flex flex-col items-center" v-if="item.img">
                <div
                    class="flex relative w-5 h-5 bg-orange-500 justify-center items-center m-1 mr-2 w-4 h-4 mt-1 rounded-full ">
                  <img class="rounded-full" alt="A" :src="item.img">
                </div>
              </div>
              <div class="w-full items-center flex">
                <div class="mx-2 -mt-1  ">{{ item[textfield] }}
                  <div class="text-xs truncate w-full normal-case font-normal -mt-1 text-gray-500">
                    {{ item.description }}
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "autocompleteBack",
  props: {
    value: null,
    label_class:{
      type:String,
      default:()=>null
    },
    items: {
      type: Array,
      default: []
    },
    textfield: {
      type: String,
      default: 'text'
    },
    valuefield: {
      type: String,
      default: 'text'
    },
    placeholder: {
      type: String,
      default: 'Search'
    },
    label: {
      type: String,
      default: ''
    },
    errorMessage: {
      type: String,
      default: 'No valido'
    },
    state: {
      default: null
    }, validMessage: {
      type: String,
      default: 'Valido'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showDetail: false,
    text: '',
    lengthElements: [],
    indexElementActive: null
  }),
  methods: {
    ocultar() {
      this.showDetail = false
    },
    changeShowDetail() {
      this.showDetail = !this.showDetail
    },
    selectItem(item) {
      this.$emit('change', item)
      this.text = item[this.textfield]
      this.showDetail = false
    },
    isShow(e) {
      if (e.keyCode === 27) {
        this.showDetail = false
        return null
      } else if (e.keyCode === 40) {
        //down
        this.indexElementActive = this.indexElementActive === null ? 0 : this.indexElementActive + 1
        if (this.indexElementActive >= this.lengthElements)
          this.indexElementActive = 0
        //pasar que el scroll me siga
        let element = this.$refs[this.refElement(this.indexElementActive)]
        this.$refs.autocompletedetail.scrollTop = element[0].offsetTop;

      } else if (e.keyCode === 38) {
        //up
        this.indexElementActive--
        if (this.indexElementActive < 0) this.indexElementActive = this.lengthElements - 1

        //pasar que el scroll me siga
        let element = this.$refs[this.refElement(this.indexElementActive)]
        this.$refs.autocompletedetail.scrollTop = element[0].offsetTop;
      } else if (e.keyCode === 13) {
        //  enter
        if (this.indexElementActive !== null)
          this.selectItem(this.searching[this.indexElementActive])
      } else if(e.keyCode===8){
        this.$emit('change', null)
      } else {
        if (!this.showDetail) this.showDetail = true
      }
      this.$emit('keyup', this.text)
    },
    refElement(index) {
      return `element${index}`
    },
    buscarText() {
      if (this.value === null) {
        // this.text = null
      } else {
        if (this.items.length > 0) {
          let element = this.items.find(item => item[this.valuefield] === this.value)
          if (element)
            this.text = element[this.textfield]
        }
      }
    },
    removeAccents(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
  },
  computed: {
    searching() {
      let aux = []
      this.items.forEach(element => {
        if (this.removeAccents(element[this.textfield].toLowerCase()).includes(this.removeAccents(this.text.toLowerCase()))) {
          aux.push(element)
        }
      })
      this.lengthElements = aux.length
      return aux
    },

  },
  watch: {
    value() {
      if (this.value && this.value.id) {
        this.text = this.value[this.textfield]
      }else if(this.value===null && this.text!==null && this.text!=='') this.text=''
    },
    text() {
      if (this.text === null || this.text === '') {
        this.text=''
      }
    },
    items() {
      this.buscarText()
    }
  },
  mounted() {
    this.buscarText()

  }
}
</script>

<style scoped>
.top-100 {
  top: 100%
}

.bottom-100 {
  bottom: 100%
}

.max-h-select {
  max-height: 300px;
}
</style>
